import { Typography } from '@mui/material';
import { MessagesLoadingContext } from 'components/@home/@messages/ChatPanel/ChatPanelContext';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { I18n } from 'utils/i18n';
import connector from './connector';

const ChatHeaderStatus = ({
  lastSeen = null,
  isOnline = false,
  typing = false,
  isDirect = false,
  loading = false,
  userCount,
}) => {
  const { loadingMoreMessages } = useContext(MessagesLoadingContext);
  const isLoading = loading || !!loadingMoreMessages;
  const getStatus = () => {
    if (isLoading) {
      return I18n.t('ChatHeaderStatus.Loading');
    }
    if (typing) {
      return I18n.t('ChatHeaderStatus.Typing', {
        name: typing,
      });
    }
    if (!isDirect) {
      if (userCount < 1) {
        return null;
      }
      return I18n.t('ChatHeaderStatus.N_Members', {
        num: userCount,
      });
    }
    if (isOnline) {
      return I18n.t('ChatHeaderStatus.Online');
    }
    if (lastSeen) {
      return I18n.t('ChatHeaderStatus.Last_seen', {
        ago: moment.unix(lastSeen).calendar(null, {
          sameDay: 'LT',
          lastDay: `[${I18n.t('ChatHeaderStatus.Yesterday')} ${I18n.t('ChatHeaderStatus.at')}] LT`,
          lastWeek: `dddd [${I18n.t('ChatHeaderStatus.at')}] LT`,
          sameElse: 'LL',
        }),
      });
    }
    return null;
  };
  const status = getStatus();
  return status ? (
    <Typography
      variant="caption"
      sx={{
        display: 'block',
      }}
    >
      {status}
    </Typography>
  ) : null;
};

ChatHeaderStatus.propTypes = {
  userCount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  isDirect: PropTypes.bool,
  lastSeen: PropTypes.number,
  isOnline: PropTypes.bool,
  typing: PropTypes.bool,
};

export default connector(ChatHeaderStatus);
